module.exports = __webpack_public_path__ + "static/media/AB_figures_desktop_reseller.be77a0d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AB_figures_desktop_reseller.png
// module id = 265
// module chunks = 0